import WorkExperience from './WorkExperience';
import Education from './Education';
import ProfessionalSkills from './ProfessionalSkills';
import GetInTouch from './GetInTouch';

export default {
  WorkExperience,
  Education,
  ProfessionalSkills,
  GetInTouch,
};



// WEBPACK FOOTER //
// ../components/Blocks/index.jsx